import React from 'react';
import { IconPhone } from '@tabler/icons-react';
import { BButton } from '../ui/generic';

const PhoneHelp = () => {
  return (
    <div className={'bg-white w-full min-w-[245.5px] rounded-2xl border border-slate-200 p-6'}>
      <div className={'flex flex-col gap-2.5'}>
        <div className={'flex gap-2 items-center '}>
          <div className={'bg-primary-50 text-primary-600 size-8 rounded-lg flex items-center justify-center'}>
            <IconPhone className={'size-5'} />
          </div>
          <p>Besoin d'aide ?</p>
        </div>
        <p className={'text-xs font-normal text-slate-400'}>
          Nous vous recommandons de contacter notre Hotline qui vous apportera des réponses ou vous redirigeras vers le
          bon interlocuteur.
        </p>
        <div className={'grid grid-cols-2 gap-1 text-xs font-normal text-slate-400 italic'}>
          <div>Lundi</div>
          <div>9h15 - 18h</div>

          <div>Mardi</div>
          <div>9h15 - 17h</div>

          <div>Mercredi</div>
          <div>8h45 - 14h</div>

          <div>Jeudi</div>
          <div>9h15 - 18h</div>

          <div>Vendredi</div>
          <div>8h45 - 16h</div>
        </div>
        <form action={'tel:0171182397'}>
          <BButton type="submit" icon={IconPhone} label={'01 71 18 23 97'} size={'xs'} />
        </form>
      </div>
    </div>
  );
};

export default PhoneHelp;
